import { useEffect, useState } from 'react';
import { Chart, ChartProps } from 'react-chartjs-2';

// Detect server-side rendering environment
const isBrowser = typeof window !== 'undefined';

export function SafeChart(props: ChartProps) {
  const [mounted, setMounted] = useState(false);

  // Only render chart after component is mounted in the browser
  useEffect(() => {
    setMounted(true);
    
    // Safety mechanism to prevent chart rendering in SSR
    return () => {
      setMounted(false);
    };
  }, []);

  // Don't render anything during SSR or when not mounted
  if (!isBrowser || !mounted) {
    return <div className="h-full w-full bg-gray-50 animate-pulse rounded" />;
  }

  // Regular chart with no ref handling - react-chartjs-2 handles cleanup internally
  return <Chart {...props} />;
}